module.exports = __webpack_public_path__ + "media/icons/favourite-no@2x-3e55cab3.png";